"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    LocalePickerOptions: function() {
        return LocalePickerOptions;
    },
    getDisplayName: function() {
        return getDisplayName;
    }
});
const _react = /*#__PURE__*/ _interop_require_wildcard(require("react"));
const _localisationeq1 = require("@equiem/localisation-eq1");
const _DropdownItem = require("../Dropdown/DropdownItem/DropdownItem");
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interop_require_wildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {
        __proto__: null
    };
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
const defaultLanguages = [
    {
        value: "en-US",
        label: "English US"
    },
    {
        value: "en-AU",
        label: "English AU"
    },
    {
        value: "en-CA",
        label: "English CA"
    },
    {
        value: "en-GB",
        label: "English UK"
    },
    {
        value: "de",
        label: "Deutsch"
    },
    {
        value: "es",
        label: "Español"
    },
    {
        value: "fr",
        label: "Français"
    },
    {
        value: "pl",
        label: "Polski"
    },
    {
        value: "hu",
        label: "Magyar"
    },
    {
        value: "nl",
        label: "Nederlands"
    },
    {
        value: "sk",
        label: "Slovenčina"
    },
    {
        value: "cs",
        label: "Čeština"
    },
    {
        value: "pt-PT",
        label: "Português"
    }
];
const defaultDebugLanguages = [
    {
        value: "ja",
        label: "日本語"
    },
    {
        value: "en",
        label: "English (Base)"
    },
    {
        value: "en-US-debug",
        label: "English (Debug)"
    },
    {
        value: "en-US-debug-longer",
        label: "English (Debug +25%)"
    }
];
const getDisplayName = (language, showDebugLanguages)=>{
    var _find;
    const resolvedLanguage = language === "en" && !showDebugLanguages ? "en-US" : language;
    return (_find = [
        ...defaultLanguages,
        ...defaultDebugLanguages
    ].find((option)=>option.value === resolvedLanguage)) === null || _find === void 0 ? void 0 : _find.label;
};
const LocalePickerOptions = (param)=>{
    let { languages = defaultLanguages, debugLanguages = defaultDebugLanguages, showSelected = false, showDebugLanguages = false } = param;
    const { i18n } = (0, _localisationeq1.useTranslation)();
    const options = (0, _react.useMemo)(()=>{
        const list = showDebugLanguages ? [
            ...languages,
            ...debugLanguages
        ] : [
            ...languages
        ];
        return list.sort((a, b)=>a.label.localeCompare(b.label, i18n.language));
    }, [
        debugLanguages,
        i18n.language,
        languages,
        showDebugLanguages
    ]);
    const setLanguage = (newLanguage)=>{
        i18n.changeLanguage(newLanguage)// eslint-disable-next-line no-console
        .catch((err)=>console.error("Failed to set language:", err));
    };
    return /*#__PURE__*/ _react.default.createElement(_react.default.Fragment, null, options.map((param)=>{
        let { value, label } = param;
        return /*#__PURE__*/ _react.default.createElement(_DropdownItem.DropdownItem, {
            key: value,
            selected: showSelected && value === i18n.language,
            onClick: ()=>setLanguage(value)
        }, label);
    }));
};

//# sourceMappingURL=LocalePickerOptions.js.map